import React from "react";
import { FacilityMissingDocsEditTemplate } from "themes/application/facility-missing-docs/components";
import { observer } from "mobx-react";

@observer
class FacilityMissingDocsEdit extends React.Component {
	render() {
		return <FacilityMissingDocsEditTemplate {...this.props} />;
	}
}

export default FacilityMissingDocsEdit;